import React from "react";

import { useGetFootprintingFarmFootprint, useTranslation } from "utils";

import { FormFlowOverlay, FormPage } from "components";

import { FarmElectricityForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmElectricityForm";
import { FarmFuelForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmFuelForm";
import { FarmRefrigerantsForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmRefrigerantsForm";
import { FarmSoilForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmSoilForm";
import { FarmTransportForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmTransportForm";
import { FarmWasteForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmWasteForm";
import { LandUseForm } from "pages/app/footprinting/components/formFlows/farmFlow/LandUseForm";

interface FarmFlowProps {
  showFormFlow: boolean;
  onExit: () => void;
  farmId: string;
  year: number;
  readOnly?: boolean;
  initialStep?: number;
  editMode?: boolean;
}

export const FarmFormFlow = ({ showFormFlow, readOnly, onExit, farmId, year, initialStep, editMode }: FarmFlowProps) => {
  const { t } = useTranslation("footprinting");
  const farmProgressQuery = useGetFootprintingFarmFootprint(farmId, year);

  const farmFlowSteps: FormPage[] = [
    {
      title: t("navigation.farm.soil"),
      body: () => <FarmSoilForm readOnly={readOnly} primaryDataId={farmProgressQuery.data?.footprint?.id} farmId={farmId} year={year} />,
    },
    {
      title: t("navigation.farm.electricity"),
      body: () => <FarmElectricityForm readOnly={readOnly} primaryDataId={farmProgressQuery.data?.footprint?.id} farmId={farmId} year={year} />,
    },
    {
      title: t("navigation.farm.waste"),
      body: () => <FarmWasteForm readOnly={readOnly} primaryDataId={farmProgressQuery.data?.footprint?.id} farmId={farmId} year={year} />,
    },
    {
      title: t("navigation.farm.fuel"),
      body: () => <FarmFuelForm readOnly={readOnly} primaryDataId={farmProgressQuery.data?.footprint?.id} farmId={farmId} year={year} />,
    },
    {
      title: t("navigation.farm.cooling"),
      body: () => <FarmRefrigerantsForm readOnly={readOnly} primaryDataId={farmProgressQuery.data?.footprint?.id} farmId={farmId} year={year} />,
    },
    {
      title: t("navigation.farm.transport"),
      body: () => <FarmTransportForm readOnly={readOnly} primaryDataId={farmProgressQuery.data?.footprint?.id} farmId={farmId} year={year} />,
    },
    {
      title: t("navigation.farm.landuse"),
      body: () => <LandUseForm readOnly={readOnly} primaryDataId={farmProgressQuery.data?.footprint?.id} farmId={farmId} year={year} />,
    },
  ];

  return (
    <FormFlowOverlay
      dataTestId="farm-form-flow-overlay"
      showModal={showFormFlow}
      onFormClose={onExit}
      formPages={farmFlowSteps}
      completionPercent={farmProgressQuery.data?.completionPct ?? 0}
      initialStep={initialStep}
      getPageStatus={(pageNumber) => {
        if (farmProgressQuery.data?.pagesCompleted.includes(pageNumber)) return "complete";
        if (farmProgressQuery.data?.pagesIncomplete.includes(pageNumber)) return "incomplete";
        return null;
      }}
      navBarTitle={t("navigation.farm.navBarTitle", { year })}
      editMode={editMode}
    />
  );
};
